import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Escucha en tiempo real la colección "costoEnvio" y devuelve el primer
// documento que encuentre (se espera que haya uno solo, con los campos
// "montoMinimo" y "precio"). Si la colección está vacía o falla la
// conexión, no llama al callback y queda el valor por defecto (hardcodeado
// en App.js) hasta que Firebase responda.
export function listenCostoEnvio(callback) {
  const colRef = collection(db, "costoEnvio");

  const unsubscribe = onSnapshot(
    colRef,
    (snapshot) => {
      if (snapshot.empty) return;

      const datos = snapshot.docs[0].data();
      callback(datos);
    },
    (error) => {
      console.error("Error al escuchar costoEnvio:", error);
    }
  );

  return unsubscribe;
}
